// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 849 ? "eda" : chunkId) + "." + {"261":"a4631811","849":"63f6c3ba"}[chunkId] + ".js";
};